import { fetch } from '@atlassian/eoc-fetch';

import { urls } from '../../../common/constants/urls';

import type {
	CloneScheduleParameters,
	CloneScheduleResponse,
	CreateScheduleParameters,
	CreateScheduleResponse,
	ScheduleRightsResponse,
} from './types';

const getScheduleRights = (teamId: string) => {
	return fetch<ScheduleRightsResponse>(urls.schedules.teams.teamId.rights.url({ teamId }));
};

const createSchedule = ({ description, name, teamId, timezone }: CreateScheduleParameters) => {
	return fetch<CreateScheduleResponse>(urls.schedules.url(), {
		method: 'POST',
		body: {
			description,
			name,
			teamId,
			timezone,
			// Created schedules are enabled by default
			enabled: true,
		},
	});
};

const cloneSchedule = ({
	description,
	name,
	enabled,
	timezone,
	teamId,
	scheduleId,
}: CloneScheduleParameters) => {
	return fetch<CloneScheduleResponse>(urls.schedules.scheduleId.clone.url({ scheduleId }), {
		method: 'POST',
		body: {
			description,
			name,
			enabled,
			timezone,
			teamId,
		},
	});
};

export const endpoints = { createSchedule, getScheduleRights, cloneSchedule };
